module.exports = __webpack_public_path__ + "static/img/iphone_room_title4.4f9a466.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/iphone_room_title4.png
// module id = x/nI
// module chunks = 0